<template>
  <div id="SelectMultiGrpDb">
    <vue-bootstrap4-table
      :rows="this.$store.state.TarifSematha.DataGrpDb"
      :columns="this.$store.state.columns"
      :config="config"
      :classes="classes"
    >
      <template slot="sort-asc-icon">
        <i class="fa fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fa fa-sort"></i>
      </template>
      <template slot="Select-slot" slot-scope="props" class="text-center">
        <a href="#" class="mr-2 badge" @click="OnDelete(props.row)"
          ><span class="fa fa-remove text-danger" style="font-size: 20px"></span
        ></a>
      </template>
    </vue-bootstrap4-table>
  </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
export default {
  data() {
    return {
      posts: null,
      columns: [],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [5, 10, 20, 30],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: false,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: "جستجو",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      ListIdDb: [],
      classes: { table: "table-bordered table-striped table-sm" },
      DataAxiosDelete: {
        ArryfildValue: "",
        Method: "Delete",
        Action: "DastresiDB",
        Token: this.$session.get("Token"),
      },
      Sweet: [
        "حذف اطلاعات",
        "آیا از حذف این اطلاعات اطمینان دارید ؟",
        "warning",
        false,
      ],
      CombooGrpDb: this.$store.state.TarifSematha.RowsGridGrpDb,
      GrpDb: this.$store.state.TarifSematha.DataGrpDb[0],
      DataAxoisCheckedIdDb: {
        ArryfildValue: "",
        Action: "DastresiDB",
        Token: this.$session.get("Token"),
      },
    };
  },
  props: ["ParentPage", "Data"],
  methods: {
    IsChecked(id) {
      var DataGrpDb = this.$store.state.TarifSematha.DataGrpDb[0];
      if (id == DataGrpDb.Id) {
        document.getElementById(id);
        return "checked";
      }
    },

    OnDelete(row) {
      //console.log(row.Id)
      this.DataAxiosDelete.ArryfildValue = { id: row.Id };
      this.$DeleteData(this.DataAxiosDelete, this.Sweet);
    },
  },
  components: {
    VueBootstrap4Table,
  },
  // beforeUpdate(){
  //           this.$store.state.TarifSematha.ChechedGrpDb=[null];
  //     var element=document.getElementById("SelectMultiGrpDb").querySelectorAll("input[type='checkbox']");
  //      for (let index = 0; index < element.length; index++)
  //      {
  //        if (element[index].checked) {
  //          console.log(element[index].id);
  //           this.$store.state.TarifSematha.ChechedGrpDb.push(element[index].id)
  //        }
  //      }

  // },
  computed: {},
};
</script>
<style scoped>
.form-check-input {
  position: unset;
}
.btn {
  border-radius: 0px;
}
</style>
